import { useId } from "react";

/** Native radios preserve browser keyboard behavior and inherited fieldset locking. */
export function PartyChoice({ label, value, onChange, options, name, disabled = false }: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: readonly { value: string; label: string }[];
  name?: string;
  disabled?: boolean;
}) {
  const generatedName = useId();
  return <fieldset className="party-choice min-w-0" disabled={disabled}>
    <legend className="mb-2 text-sm font-medium">{label}</legend>
    <div className="flex gap-2 flex-wrap">{options.map(option => <label key={option.value} className="party-option">
      <input type="radio" className="sr-only" name={name || generatedName} value={option.value} checked={value === option.value} onChange={() => onChange(option.value)} />
      <span className="party-dot" aria-hidden="true" />
      <span>{option.label}</span>
    </label>)}</div>
  </fieldset>;
}
